<template>
	<div class="home">
		<Homeindex ></Homeindex>
	</div>
</template>

<script>
import Homeindex from "../components/Home/HomeIndex.vue"
export default {
	name: 'Home',
	components: {
		Homeindex,
	},
	data() {
		return {
			type: '',//1 模板缴费 2 单笔 3 列表 5 选品 6 自定义选品
		};
	},
	created() {
	}

}
</script>
<style></style>
